import React, {Component} from 'react';
import Breadcrumb from "../common/breadcrumb";
import { stopTimer, sendForgotCode, resetPassword, putToast} from "../api";
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { Button} from 'reactstrap';
import queryString from "query-string";

class ForgotPassword extends Component {
    constructor (props) {
        super(props);
        const value=queryString.parse(this.props.location.search);

        this.state = {
            em: value.em,
            isReceiving: false,
            resetCode: ""
        }
    }

    onValidSubmit = (event, values) => {
        if (this.state.isReceiving) {
            var success = true;
            if (!values.resetCode || values.resetCode.length === 0) {success = false; putToast.error("Please enter the reset code"); }
            if (!values.password || values.password.length === 0) {success = false; putToast.error("Please enter new password"); }
            if (values.password !== values.passwordC) {success = false; putToast.error("Passwords do not match"); }
            if (success) {
                resetPassword(values).then(d3 => {
                    if (d3 && d3.error) {
                        console.log(d3.error);
                        putToast.error(d3.error);
                    } else {
                        if (d3.status === 200) { 
                            putToast.success("Password Successfully changed.")
                            this.props.history.push(`/pages/login?&em=${this.state.em}`) }
                    }
                });
            }
        } else {
            sendForgotCode(values.email).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                    putToast.error(d2.error);
                } else {
                    putToast.success(d2.message);
                    this.setState({ data: d2, isReceiving: true, loading: false});                    
                }
            });    
        }
    };
    
    onInvalidSubmit = (event, errors, values) => {
        //this.setState({errors, values});
    };
        
    render (){
        stopTimer();        

        return (
            <div>
                <Breadcrumb title={'forgot password'}/>
                                
                <section className="pwd-page section-b-space">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 offset-lg-3">
                                <h2>Forgot Your Password</h2>
                                <AvForm id="loginForm" className="theme-form" onValidSubmit={this.onValidSubmit} onInvalidSubmit={this.onInvalidSubmit} >
                                    <div className="form-group">
                                        {this.state.isReceiving
                                        ?   <> 
                                            <AvField readOnly required="" name="email" type="email" defaultValue={this.state.em} className="form-control" placeholder="Enter Your Email Address" />
                                            <AvField required="" name="resetCode" type="text" defaultValue={this.state.resetCode} className="form-control" placeholder="Enter the Code" />
                                            <AvField id="password" name="password" type="password" className="form-control" placeholder="new password" />
                                            <AvField id="passwordC" name="passwordC" type="password" className="form-control" placeholder="confirm new password" />
                                            </>
                                        :    <AvField required="" name="email" type="email" defaultValue={this.state.em} className="form-control" placeholder="Enter Your Email Address" />
                                        }
                                    </div>
                                    {this.state.isReceiving 
                                    ?    <Button type="submit" className="btn btn-solid pull-right">Submit Code</Button>
                                    :    <Button type="submit" className="btn btn-solid pull-right">Send Code</Button>
                                    }
                                </AvForm>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        )
    }
}

export default ForgotPassword